// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Info2: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<path d="M12,0.05c3.19,0,6.19,1.24,8.45,3.5l0,0l0,0c2.26,2.26,3.5,5.26,3.5,8.45c0,3.19-1.24,6.19-3.5,8.45
	c-2.26,2.26-5.26,3.5-8.45,3.5c-3.19,0-6.19-1.24-8.45-3.5c-2.26-2.26-3.5-5.26-3.5-8.45c0-3.19,1.24-6.19,3.5-8.45
	C5.81,1.29,8.81,0.05,12,0.05z M12,22.55c2.82,0,5.47-1.1,7.46-3.09c1.99-1.99,3.09-4.64,3.09-7.46c0-2.82-1.1-5.47-3.09-7.46l0,0
	C17.47,2.55,14.82,1.45,12,1.45c-2.82,0-5.47,1.1-7.46,3.09C2.55,6.53,1.45,9.18,1.45,12c0,2.82,1.1,5.47,3.09,7.46
	C6.53,21.45,9.18,22.55,12,22.55z"/>
<rect x="11.3" y="9.46" width="1.4" height="7.98"/>
<rect x="11.3" y="6.56" width="1.4" height="1.45"/>
</svg>;
};

export default React.memo(Info2);
